<div class="mt-5 mb-5 p-4 rounded-lg w-full">
  @if (tituloHeader()) {
    <h2 class="text-2xl mb-4 ml-4 border-b pb-2">
      {{ tituloHeader() }}
    </h2>
  }

  <div class="flex flex-wrap gap-4">
    @for (item of items(); track item.titulo) {
      <div
        class="card"
        [routerLink]="item.notAllowed ? null : item.link"
        [pTooltip]="item.notAllowed ? 'No tiene permiso de acceso' : ''"
        tooltipPosition="bottom"
        [ngClass]="{ 'card-disabled': item.notAllowed }"
      >
        <div class="flex flex-col pl-8 w-full relative">
          <img
            src="svg/{{ item.svg }}.svg"
            alt="Ícono"
            class="transition-all duration-200"
            [ngClass]="{
              'w-8': small,
              'w-5': !small,
              'grayscale opacity-50': item.notAllowed,
            }"
          />
          <h1
            class="flex items-center gap-2"
            [ngClass]="{
              'text-xl': small,
              'text-base font-bold': small,
              'text-gray-400': item.notAllowed,
            }"
          >
            {{ item.titulo }}
          </h1>

          @if (item.descripcion) {
            <span class="text-md text-gray-400">
              {{ item.descripcion }}
            </span>
          }

          @if (item.notAllowed) {
            <div
              class="absolute bottom-2 right-4 flex items-center gap-1 text-gray-400 text-xs font-semibold uppercase tracking-wider select-none">
              <i class="pi pi-lock text-sm"></i>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
